// Polyfills
import 'babel-polyfill';

// React Redux
import 'react';
import 'react-dom';
import 'react-hot-loader';
import 'react-redux';
import 'react-router-dom';
import 'react-router-redux';
import 'redux';
import 'redux-thunk';

//
import 'classnames';
import 'firebase';
import 'history';
import 'immutable';
import 'lodash';
import 'moment';
import 'reselect';



// WEBPACK FOOTER //
// ./src/vendor.js